import { IFacetOption } from 'shared/types/ConstructorFacet';
import { GENDER_SORT, SIZE_SORT } from 'search/enums/constants';

/**
 * [transformSizeFacet]
 * returns an object with the product type as the top level key and
 * gender as its nested keys
 * {
 * sneakers: {
 *   women: [...],
 *   men: [...],
 *   infant: [...],
 *  },
 * tops: {
 *   women: [...],
 *   men: [...],
 *  },...
 * }
 * @param sizeOptions { Array<IFacetOption> }
 */

export const transformSizeFacet = (sizeOptions: Array<IFacetOption>) => {
  const sizeMap = {};

  sizeOptions.forEach((option) => {
    const { product_type: productType, gender } = option.data;

    if (!productType || !gender) return;

    if (sizeMap[productType]) {
      if (sizeMap[productType][gender]) {
        sizeMap[productType][gender] = [...sizeMap[productType][gender], option];
      } else {
        sizeMap[productType][gender] = {};
        sizeMap[productType][gender] = [option];
      }
    } else {
      sizeMap[productType] = {};
      sizeMap[productType][gender] = [option];
    }
  });

  return sizeMap;
};

export const sortSizesByDisplayName = (a, b) => {
  const aDisplayName = a.display_name?.toLowerCase();
  const bDisplayName = b.display_name?.toLowerCase();
  const aNumber = Number(aDisplayName);
  const bNumber = Number(bDisplayName);

  if (Number.isNaN(aNumber) || Number.isNaN(bNumber)) {
    return SIZE_SORT.indexOf(aDisplayName) - SIZE_SORT.indexOf(bDisplayName);
  }

  if (aNumber < bNumber) {
    return -1;
  }
  if (aNumber > bNumber) {
    return 1;
  }
  return 0;
};

export const sortGender = (a, b) => {
  return GENDER_SORT.indexOf(a?.toLowerCase()) - GENDER_SORT.indexOf(b?.toLowerCase());
};
